export var UNAVAILABLE = 'unavailable';
export var CONSENT_GRANTED = 'GRANTED';
export var CONSENT_DECLINED = 'DECLINED';
export var CONSENT_UNKNOWN = 'UNKNOWN';
export var DEFAULT_PREFIX = 'split.rum';
